import { getRuntimeConfigFromSever } from 'src/utils/school'
import { isEmpty } from 'src/utils/utils';

let config: any = null;
let errorCnt = 0;


const setDefaultConfig = () => {
    errorCnt++;
    console.warn('Error count : ', errorCnt);
    config = {
        "aiMinDate":"2020-9-1",
        "aiBatchSize":10,
        "diMinDate":"2023-11-1",
        "diBatchSize":14
    }
}
export const getRuntimeConfig:any = async () => {
    let runtimeConfig;

    // Try to load the config from server, if failed, use default config
    // If failed 2 times, stop trying
    if ( !config || (config && errorCnt > 0 && errorCnt < 2) ) {
        console.log('getRuntimeConfig: loading runtime config from server');
        try {
            runtimeConfig = await getRuntimeConfigFromSever();
            if ( isEmpty(runtimeConfig) ) {
                console.error('getRuntimeConfig returned Empty Config');
                setDefaultConfig();
            } else {
                config = runtimeConfig;
            }
        } catch (e) {
            console.error('getRuntimeConfig: failed to load runtime config from server', e);
            setDefaultConfig();
        }
        console.log('Got Runtime Config : ', runtimeConfig);
    }
    return config;
}